// Mounted in the authed app shell. Implements the "auto-move on approval"
// decision: when a school admin approves this user's join request, their own
// client finalizes the move (no Cloud Function needed).
import { useEffect } from "react";
import { collection, query, where, onSnapshot, deleteDoc, doc } from "firebase/firestore";
import { firestore } from "./FirebaseConfig";
import { useUser } from "./UserContext";
import { finalizeApprovedJoin } from "./joinRequests";

export default function JoinRequestWatcher() {
  const { uid, schoolId } = useUser();

  useEffect(() => {
    if (!uid) return;
    // Single-field query (no composite index needed); filter status client-side.
    const q = query(collection(firestore, "joinRequests"), where("requesterUid", "==", uid));
    return onSnapshot(q, (snap) => {
      snap.docs.forEach(async (d) => {
        const data = d.data();
        if (data.status !== "approved") return;
        try {
          if (data.schoolId && data.schoolId !== schoolId) {
            await finalizeApprovedJoin({ uid, schoolId: data.schoolId, schoolName: data.schoolName });
          } else {
            // Already in the school — clean up the leftover approved request.
            await deleteDoc(doc(firestore, "joinRequests", d.id));
          }
        } catch (err) {
          console.error("Join finalize failed:", err);
        }
      });
    });
  }, [uid, schoolId]);

  return null;
}
